"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hyperformula = _interopRequireDefault(require("hyperformula"));
var _MomentAdapter = require("./MomentAdapter");
var _ToCurrency = require("../Hyperformula/ToCurrency");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var hfConfig = {
  licenseKey: "gpl-v3",
  dateFormats: ['MM/DD/YYYY', 'MM/DD/YY', "YYYY-MM-DD"],
  parseDateTime: _MomentAdapter.customParseDate
};
_hyperformula.default.registerFunctionPlugin(_ToCurrency.ToCurrency, _ToCurrency.ToCurrencyTranslations);
var FormulaParser = /*#__PURE__*/_createClass(function FormulaParser() {
  _classCallCheck(this, FormulaParser);
});
_defineProperty(FormulaParser, "interpolationRegex", /[^{\}]+(?=})/g);
_defineProperty(FormulaParser, "getVariablesAndValues", function (formula, previousAnswers) {
  try {
    if (!formula) {
      return null;
    }

    // Get a list of all of the variables used
    var variableNames = formula.match(FormulaParser.interpolationRegex);
    if (!variableNames) {
      return null;
    }
    var interpolatedVariables = {};
    for (var iterator = 0; iterator < variableNames.length; iterator++) {
      var variableName = variableNames[iterator];
      if (variableName in interpolatedVariables) {
        continue;
      }
      var value = FormulaParser.replaceWithValue(variableName, "{" + variableName + "}", previousAnswers);
      if (!value) {
        value = "";
      }
      interpolatedVariables[variableName] = value;
    }
    return interpolatedVariables;
  } catch (ex) {
    console.log("Error getting variables and values for forula " + formula);
    return null;
  }
});
_defineProperty(FormulaParser, "executeFormula", function (formula, previousAnswers) {
  try {
    if (!formula) {
      return null;
    }
    var variablesRecorded = [];

    // Get a list of all of the variables used
    var variableNames = formula.match(FormulaParser.interpolationRegex);
    if (!variableNames) {
      throw "No variables need to be interpreted";
    }

    // Create a column of data and take the user's formula and replace the variable names with cell references
    var interpolatedVariables = [];
    var formulaWithCellReferences = formula;
    for (var iterator = 0; iterator < variableNames.length; iterator++) {
      var variableName = variableNames[iterator];
      var value = FormulaParser.replaceWithValue(variableName, "{" + variableName + "}", previousAnswers);
      if (!value) {
        value = "";
      }
      variablesRecorded.push(variableName);
      interpolatedVariables.push([value]);
      formulaWithCellReferences = formulaWithCellReferences.replaceAll("{" + variableName + "}", "A" + (iterator + 1));
    }
    interpolatedVariables.push([formulaWithCellReferences.trim()]);

    // Run the calculations and get the cell content
    var hfInstance = _hyperformula.default.buildFromArray(interpolatedVariables, hfConfig);
    var result = hfInstance.getCellValue({
      sheet: 0,
      row: interpolatedVariables.length - 1,
      col: 0
    });
    if (_typeof(result) === "object") {
      return null;
    }
    return result;
  } catch (ex) {
    console.log("Error calculating formula " + formula);
    console.log(ex);
    return null;
  }
});
_defineProperty(FormulaParser, "replaceWithValue", function (variableName, entireString, answers) {
  var keyToReplace = "{" + variableName + "}";
  var valueToReplace = answers[variableName];
  if (/\d{4}-\d{2}-\d{2}/.test(valueToReplace)) {
    var array = valueToReplace.split("-");
    valueToReplace = array[1] + "/" + array[2] + "/" + array[0];
  }
  if (!valueToReplace) {
    return entireString;
  }
  return entireString.replaceAll(keyToReplace, valueToReplace);
});
var _default = FormulaParser;
exports.default = _default;